import * as tslib_1 from "tslib";
import * as Bus from '../../../../../../form/schema';
import { RelevanceFormControl } from "../../../../../../form/src/common/controls/relevance-form-control";
import { Icon, Radio, Select, Spin, Tooltip, TreeSelect } from "@h3/antd-vue";
import { Component, Watch } from "vue-property-decorator";
let RelevanceFormDropdown = class RelevanceFormDropdown extends RelevanceFormControl {
    constructor() {
        super(...arguments);
        this.list = [];
        this.isShowAll = false;
        this.searchTimeoutRef = null;
        this.page = 1;
        this.loadedAll = false; // 全部数据加载完成
        this.fetching = false;
        this.currentSeachValue = '';
        this.historySeachList = [];
        this.refId = 'id_001';
        this.offWidth = undefined;
        this.myRouter = '';
    }
    // 返回搜索字段之前的文字
    preHighlightText(value, currentSeachValue) {
        let index = value.indexOf(currentSeachValue);
        if (index < 0) {
            return '';
        }
        return value.substring(0, index);
    }
    // 返回搜索字段之后的文字
    nextHighlightText(value, currentSeachValue) {
        let index = value.indexOf(currentSeachValue);
        if (index < 0) {
            return '';
        }
        return value.substring(index + currentSeachValue.length);
    }
    // 设置高亮文字
    setHighlightText(value) {
        if (!this.currentSeachValue) { // 没有搜索返回原值
            return value;
        }
        let first = this.preHighlightText(value, this.currentSeachValue);
        let last = this.nextHighlightText(value, this.currentSeachValue);
        if (this.currentSeachValue === value) {
            return `<font>${this.currentSeachValue}</font>`;
        }
        if (!first && !last) {
            return value;
        }
        return `${first}<font>${this.currentSeachValue}</font>${last}`;
    }
    get selectedId() {
        if (this.ctrl.value) {
            return this.ctrl.value.id || undefined;
        }
        return undefined;
    }
    get selectedItem() {
        if (this.selectedId && this.list.length === 0) {
            return this.parseDisplayFieldValue(this.ctrl.value[this.getDisplayField], this.getDisplayField);
        }
        return "";
    }
    get treeList() {
        if (this.list.length) {
            let arr = [];
            for (let val of this.list) {
                if (val[this.getDisplayField] !== null && val[this.getDisplayField] !== '') {
                    let titles = val[this.getDisplayField];
                    try {
                        //处理地址数据在前台显示异常
                        let parseTitle = JSON.parse(val[this.getDisplayField]) ? JSON.parse(val[this.getDisplayField]) : '';
                        if (parseTitle && parseTitle.valString) {
                            titles = parseTitle.valString;
                        }
                    }
                    catch (_a) { }
                    //人员、部门控件作为树形显示字段时数据格式跟普通数据项不一样
                    if (Array.isArray(titles) && titles.length > 0) {
                        titles = titles.map((titleItem) => {
                            return titleItem['name'];
                        }).join(',');
                    }
                    arr.push({
                        value: val.id,
                        key: val.id,
                        title: titles,
                        scopedSlots: { title: 'tree', },
                        children: this.childrenToTreeList(val.t__children_)
                    });
                }
            }
            return arr;
        }
        else {
            return [];
        }
    }
    //把传过来的关联数据项的子列表做一个清洗，变成符合treeList的数据类型
    childrenToTreeList(children) {
        if (!children)
            return;
        let arr = [];
        for (let i = 0; i < children.length; i++) {
            if (children[i].data[this.getDisplayField]) {
                arr.push({
                    value: children[i].data.id || "",
                    key: children[i].data.id,
                    title: children[i].data[this.getDisplayField],
                    scopedSlots: { title: 'tree', },
                    children: this.childrenToTreeList(children[i].data.t__children_)
                });
            }
        }
        return arr;
    }
    get drowdownList() {
        if (this.list.length) {
            let arr = [];
            for (let val of this.list) {
                if (val[this.getDisplayField] && val[this.getDisplayField] !== null && val[this.getDisplayField] !== '') {
                    let value = this.parseDisplayFieldValue(val[this.getDisplayField], this.getDisplayField);
                    arr.push({
                        id: val.id,
                        [this.getDisplayField]: value
                    });
                }
            }
            return arr;
        }
        else {
            return [];
        }
    }
    setControl() {
        super.setControl();
        if (this.selectedId) {
            this.onFocus();
        }
    }
    onFocus() {
        this.setOffWidth();
        this.search("");
    }
    //树形搜索功能
    treeSearch(input, option) {
        return (option.componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0);
    }
    onSearch(value) {
        clearTimeout(this.searchTimeoutRef);
        this.searchTimeoutRef = setTimeout(() => {
            this.list = [];
            this.search(value);
        }, 300);
    }
    // 保存历史最近10个查询记录
    saveHistorySeach() {
        let value = this.currentSeachValue;
        if (value === undefined || value === '') {
            return;
        }
        let index = this.historySeachList.indexOf(value);
        if (index !== -1) {
            this.historySeachList.splice(index, 1);
        }
        else {
            if (this.historySeachList.length >= 10) { // 历史查询记录大于10个，删除一个老数据
                this.historySeachList.pop();
            }
        }
        this.historySeachList.unshift(value);
        localStorage.setItem((this.ctrl.id), JSON.stringify(this.historySeachList));
    }
    // 删除历史记录
    delHistoryItem(item, obj) {
        let index = this.historySeachList.indexOf(item);
        if (index !== -1) {
            this.historySeachList.splice(index, 1);
            localStorage.setItem((this.ctrl.id), JSON.stringify(this.historySeachList));
            // const historyObj = document.querySelector('.history-'+ obj) // 双向数据绑定不能触发弹窗中的修改，使用操作dom的方式删除
            // historyObj && historyObj.remove()
        }
    }
    popupScroll($ev) {
        if ($ev.target.scrollHeight < $ev.target.offsetHeight + $ev.target.scrollTop + 64) {
            // 滚动到底||加载全部数据
            if (this.fetching || this.loadedAll || this.drowdownList[0].id === '0') {
                return;
            }
            this.page++;
            this.search(this.currentSeachValue, this.page);
        }
    }
    search(value, page) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!page) {
                this.page = 0;
            }
            this.currentSeachValue = value; // 记录最后一次加载
            if (this.queryConditions.length === 0 && this.controlOpts.conditions) {
                const res = yield this.getConfig();
                if (res && res.conditions) {
                    this.queryConditions = res.conditions;
                }
            }
            console.log(this.queryConditions, "---------FUZHUOH");
            if (this.fetching) {
                return;
            }
            this.fetching = true;
            // this.list = [];
            //目前先查找全部数据，以后做异步的展开请求，则在depth做查询深度
            let view = {
                type: this.control.options.showStyle === 'tree' ? "TREE" : "LIST",
                depth: this.control.options.showStyle === 'tree' ? 0 : undefined,
                parentRef: this.control.options.showStyle === 'tree' ? "#" : undefined,
            };
            yield this.fetch(page === undefined ? 0 : page, 1000, value, null, false, view = view).then(seg => {
                this.fetching = false;
                if (page) {
                    this.list = [...this.list, ...seg.data];
                }
                else {
                    this.list = seg.data;
                }
                this.loadedAll = seg.total === this.list.length;
            }, () => (this.fetching = false));
        });
    }
    //树形列表打平查找id
    treeToList(list) {
        if (!list)
            return [];
        let arr = list;
        for (let i = 0; i < list.length; i++) {
            if (list[i].t__children_) {
                arr = [...arr, ...this.treechildToList(list[i].t__children_)];
            }
        }
        return arr;
    }
    //树形子列表打平
    treechildToList(children) {
        if (!children)
            return [];
        let arrList = [];
        for (let i = 0; i < children.length; i++) {
            arrList.push(children[i].data || {});
            arrList = [...arrList, ...this.treechildToList(children[i].data.t__children_)];
        }
        return arrList;
    }
    onChange(selectedId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (selectedId) {
                this.saveHistorySeach(); // 记录历史搜索条件
                let arr = this.treeToList(this.list);
                let item = arr.find(x => x.id === selectedId);
                item = yield this.convertForMappings(item);
                // this.ctrl.value = item;
                this.interceptorValue(item);
                this.setValue(item);
                this.treeViewSend();
            }
            else {
                this.ctrl.value = null;
            }
        });
    }
    treeViewSend() {
        if (!this.treeView)
            return; //不是树形视图直接返回，不用发送数据给tree-query-form组件
        if (this.$route.path !== this.myRouter)
            return; //缓存的组件任然会触发delete或close事件从而触发该函数，如果触发的时候路由不相同，则不发送数据
        this.search("").then(() => {
            this.sentEventBus();
        });
    }
    sentEventBus() {
        let isValue = false; //判断是否有值，有的话树形视图那里不需要展开所有数据，否则需要展开数据
        if (this.control.value) {
            isValue = true;
        }
        Bus.EventBus.$emit('treedata', {
            list: this.list,
            treeList: this.treeList,
            controlKey: this.control.key,
            value: this.selectedId,
            visible: this.control.options.visible,
            isValue: isValue,
            name: this.control.options.name,
            setTreeView: false,
        }); //把关联单选作为查询条件视图， 且为树形， 源数据、树形数据、该控件的key值， 传输给树形视图展示控件。
    }
    created() {
        this.refId = 'id_' + +new Date();
        this.myRouter = this.$route.path;
    }
    setOffWidth() {
        // @ts-ignore
        let offWidth = document.querySelector(`#${this.refId}`) && document.querySelector(`#${this.refId}`).offsetWidth;
        if (offWidth) {
            this.offWidth = offWidth;
        }
    }
    mounted() {
        const historySeachList = localStorage.getItem((this.ctrl.id));
        if (historySeachList) {
            this.historySeachList = JSON.parse(historySeachList);
        }
        else {
            this.historySeachList = [];
        }
        let that = this;
        window.addEventListener('message', function (e) {
            if (e.data === 'close' || e.data === 'delete') {
                that.treeViewSend();
            }
        }, false);
        //把查询视图的关联单选需要的数据发送过去.
        this.treeViewSend();
    }
    getSelectedId() {
        if (this.selectedId && this.list.length === 0) {
            this.search("");
        }
        else if (this.list.length && this.list.every(item => item.id !== this.selectedId)) {
            this.search("");
        }
    }
};
tslib_1.__decorate([
    Watch("selectedId")
], RelevanceFormDropdown.prototype, "getSelectedId", null);
RelevanceFormDropdown = tslib_1.__decorate([
    Component({
        name: "relevance-form-dropdown",
        components: {
            ATooltip: Tooltip,
            ASelect: Select,
            ASelectOption: Select.Option,
            ATreeSelect: TreeSelect,
            // ATreeSelectNode: TreeSelect.TreeNode,
            AIcon: Icon,
            ASpin: Spin,
            ARadio: Radio,
            VNodes: {
                functional: true,
                render: (h, ctx) => ctx.props.vnodes,
            },
        }
    })
], RelevanceFormDropdown);
export default RelevanceFormDropdown;
